import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training',
  templateUrl: './training-soft-skill.component.html',
  styleUrls: ['./training-soft-skill.component.scss']
})
export class TrainingSoftSkillsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
